import { NODE_ENV, VERSION } from '../config/index';
import { API_URL } from '../config/urls';
import moment from 'moment';
import route from '../config/routes';
import Service from './service';
import { NETWORK, MESSAGE } from '../config/index';
import { S3 } from '../config/urls';
import routes from '../config/routes';
import Noty from 'noty';
import '../../node_modules/noty/lib/noty.css';
import '../../node_modules/noty/lib/themes/metroui.css';
const { ADD, CLOSE, CREATE, SENT, SENT_FAILED, UPDATE, DELETE, EMPTY, REQUIRE, GREAT, LESS, DECIMAL, NUMERIC, REFILL, NOT_FOUND, SELECT, IMAGE, IMPORT, IMPORT_FAILED,
    DLC, PAK, ALERT, DISABLE, ENABLE, COMPLETE, DOWNLOAD_START, DOWNLOAD_FAILED, DOWNLOAD_DATA_NOT_FOUND, LIMIT_GREAT, LIMIT_LESS, URL, SYNC, VIDEO,
    MINT, MINT_FAILED, GIFTED, GIFT_FAILED, SHUFFLE, SHUFFLE_FAILED, RELEASE, ROLE, ACCESS_CHANGE, TRANSACTION, RESERVE, MINTABLE, REPLACE, START_DATE_ERROR, END_DATE_ERROR } = MESSAGE;

export default class Helping {
    static getConfig() {
        let token = localStorage.token;

        return {
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token ? token : null,
                platform: VERSION.PLATFORM,
                version: VERSION.VERSION,
                build: VERSION.BUILD
            },
            // ,
            // redirect: 'follow',
            // referrer: 'no-referrer',
        };
    }

    static reloadThePage = (window) => {
        window.location.reload(false);
    }

    static formatDateInYearMonthDay(date) {
        if (date) {
            return moment(date).format('YYYY-MM-DD')
        }
        return ""
        // return date === "" ? "" : moment(date).format('YYYY-MM-DD');
    }

    static removeItem(items, id) {
        return items.filter(function (item) {
            return item.id !== id;
        });
    }

    static toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    static isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    static pushObjectInArray = (key = [], value = []) => {
        let result = {};
        if (key.length > 0 && value.length > 0) {
            for (let i = 0; i <= key.length; i++) {
                (Object.entries(result).length === 0 && result.constructor === Object) ?
                    result = {
                        [`${key[i]}`]: value[i]
                    } :
                    result = {
                        ...result,
                        [`${key[i]}`]: value[i]
                    };
            }
            return result;
        } else {
            return "Key | Value should not be empty.";
        }
    }

    static setSignedObject = (field, signedUrl, fileName) => ({
        [`${field}AjaxUrl`]: signedUrl,
        [`${field}`]: fileName,
        [`${field}Percent`]: 1
    })

    static progress = (evt, signedUrlData, platform) => {
        let resultObject = {},
            percent = Math.round((evt.loaded / evt.total) * 100);

        resultObject = {
            [platform + 'Percent']: percent,
            uploadingFile: true,
        };

        return {
            ...signedUrlData,
            ...resultObject,
        };
    }

    static uploadProgress = (evt, signedUrlData, platform) => {
        let resultObject = {},
            percent = Math.round((evt.loaded / evt.total) * 100);

        if (platform === "android") {
            resultObject = {
                androidPercent: percent,
                uploadingFile: true
            };
        }
        if (platform === "ios") {
            resultObject = {
                iosPercent: percent,
                uploadingFile: true
            };
        }
        if (platform === "quest") {
            resultObject = {
                questPercent: percent,
                uploadingFile: true
            };
        }
        if (platform === "vrUpdated") {
            resultObject = {
                vrUpdatedPercent: percent,
                uploadingFile: true
            };
        }
        if (platform === "vrDeprecated") {
            resultObject = {
                vrDeprecatedPercent: percent,
                uploadingFile: true
            };
        }

        if (platform === "webgl") {
            resultObject = {
                webPercent: percent,
                uploadingFile: true
            };
        }

        if (platform === "thumbnailVideoUrl") {
            resultObject = {
                thumbnailVideoUrlPercent: percent,
                uploadingFile: true
            };
        }
        return {
            ...signedUrlData,
            ...resultObject
        };
    }

    static uploadToS3 = (file, platform, signedUrlData, ajaxUrl, refMethod) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.addEventListener(
            "progress",
            function (evt) {
                refMethod(Helping.progress(evt, signedUrlData, platform));
            },
            false
        );
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                return refMethod({
                    uploadingFile: false
                })
            }
        };
        xhr.open("PUT", ajaxUrl, true);
        xhr.send(file);
    }

    static returnPromise = () => {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    }

    static signFile(fileFor, value, field, refMethod, filename = true) {
        let resultObject = {};
        if (fileFor.toLowerCase().includes('news'))
            NODE_ENV.toLowerCase() === 'production' ?
                fileFor = fileFor + "prod/" : NODE_ENV.toLowerCase().includes('stag') ?
                    fileFor = fileFor + "stag/" :
                    fileFor = fileFor + "dev/";

        const url = filename ? fileFor + value.name : fileFor;
        return Service.postCall(API_URL.ADMIN_TRADING_API + routes.GET_SETTING, {
            action: 'signed-file',
            url: url,
        })
            .then(response => {
                let { Url, File_name } = response.data.payload;
                resultObject = this.setSignedObject(field, Url, S3.URL + "/" + File_name)

                return resultObject = {
                    ...resultObject,
                    ...this.uploadToS3(value, field, resultObject, resultObject[`${field}AjaxUrl`], refMethod)
                }
            }).catch(error => console.log({ error }));
    }

    static removeSpacesFromString = (string) => {
        return string.replace(/\s/g, '');
    }

    static getSignedUrl = async (platform, name, value, isItem, dependency, refMethod, type = '') => {
        let resultObject = {},
            signedUrlParams = "";

        isItem === true ? type !== '' ? signedUrlParams = `?category=${dependency.category_name}&kind=item&brand=${dependency.ip_name}&name=${name}&platforms=${platform}&type=thumbnail_video` :
            signedUrlParams = `?category=${dependency.category_name}&brand=${dependency.ip_name}&kind=item&name=${name}&platforms=${platform}` :

            signedUrlParams = `?category=${dependency.category_name}&name=${name}&platforms=${platform}`;
        // return console.log({signedUrlParams});
        Service.getCall(`${API_URL.ADMIN_API}${route.SIGNED_INVENTORY_URL + signedUrlParams}`)
            .then(response => {
                var signedUrl = response.data.payload.signedUrl;
                let fileName = "";
                if (platform === "quest") {
                    fileName = signedUrl.quest.File_name;
                    resultObject = this.setSignedObject("quest", signedUrl.quest.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "quest", resultObject, resultObject.questAjaxUrl, refMethod)
                    }
                }

                if (platform === "android") {
                    fileName = signedUrl.android.File_name;
                    resultObject = this.setSignedObject("android", signedUrl.android.Url, S3.URL + "/" + fileName);
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "android", resultObject, resultObject.androidAjaxUrl, refMethod)
                    }
                }

                if (platform === "ios") {
                    fileName = signedUrl.ios.File_name;
                    resultObject = this.setSignedObject("ios", signedUrl.ios.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "ios", resultObject, resultObject.iosAjaxUrl, refMethod)
                    }
                }
                if (platform.includes("deprecated")) {
                    isItem ? signedUrl = signedUrl.vrdeprecated : signedUrl = signedUrl["vr/deprecated"];
                    fileName = signedUrl.File_name;
                    resultObject = this.setSignedObject("vrdeprecated", signedUrl.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "vrDeprecated", resultObject, resultObject.vrdeprecatedAjaxUrl, refMethod)
                    }
                }
                if (platform.includes("updated")) {
                    isItem ? signedUrl = signedUrl.vrupdated : signedUrl = signedUrl["vr/updated"];
                    fileName = signedUrl.File_name;
                    resultObject = this.setSignedObject("vrupdated", signedUrl.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "vrUpdated", resultObject, resultObject.vrupdatedAjaxUrl, refMethod)
                    }
                }

                if (platform === "webgl") {
                    fileName = signedUrl.webgl.File_name;
                    resultObject = this.setSignedObject("webgl", signedUrl.webgl.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "webgl", resultObject, resultObject.webglAjaxUrl, refMethod)
                    }
                }

                if (platform === "web") {
                    fileName = signedUrl.web.File_name;
                    resultObject = this.setSignedObject("thumbnailVideo", signedUrl.web.Url, S3.URL + "/" + fileName)
                    resultObject = {
                        ...resultObject,
                        ...this.uploadToS3(value, "thumbnailVideoUrl", resultObject, resultObject.thumbnailVideoAjaxUrl, refMethod)
                    }
                }
                return {
                    ...resultObject
                }
            })
            .catch(error => {
                if (error.response) {
                    this.redirectToLogin(error);
                    resultObject = {
                        error_message: error.response.data.message,
                        error_type: "danger",
                        uploadingFile: false
                    };
                }
                resultObject = {
                    error_message: error.message,
                    error_type: "danger",
                    uploadingFile: false
                };
                refMethod(resultObject);
            });
    }

    static removeKeysFromObject = (object = {}, keys = []) => {
        let updatedObject = {}
        if (keys.length > 0) {
            for (let index = 0; index < keys.length; index++) {
                delete object[keys[index]]
            }
        }
        return object;
    }

    static getTitleCase = (phrase) => {
        return this.removeSpacialCharactersFromString(phrase)
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    static getNewTitleCase = (phrase) => {
        return this.removeSpacialCharactersOtherThanNumbersFromString(phrase)
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    static isAuth(response) {
        if (!response) {
            return false;
        }

        response = response.data;

        if (Number(response.status) === 401 && (response.message.toLowerCase().includes('terminated') || response.message.toLowerCase().includes('expired'))) {
            window.location.reload();
        }

        if (Number(response.status) === 401 || Number(response.status) === 403) {
            delete localStorage.token;
            delete localStorage.profile;
            localStorage.error_message = response.message;
            window.location.href = route.LOGOUT;
        }
    }

    static redirectToLogin(error) {
        if (error.response) {
            if (Number(error.response.data.status) === 403) {
                this.isAuth(error.response);
            }
        }
    }

    static getTradingApiUrl() {
        return API_URL.ADMIN_API;
    }

    static convertTimeStampToUnixTimeStamp(timeStamp) {
        return Date.parse(moment(timeStamp).utc(false)) / 1000;
    }

    static convertToUnixTime(time) {
        return moment(time).utc(false).format("YYYY-MM-DD HH:mm:ss");
    }

    static convertUnixTimeStampToDateTime(unixTimeStamp) {
        return new Date(unixTimeStamp * 1000);
    }

    static currentDate() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (day < 10)
            day = '0' + day;
        if (month < 10)
            month = '0' + month;

        return year + '-' + month + '-' + day;
    }

    static currentTimeStampInISO() {
        let date = new Date();
        date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        date.setSeconds(0, 0);
        return (date.toISOString()).slice(0, -1);
    }

    static convertUnixTimeStampToISO(unixTimeStamp) {
        let date = this.convertUnixTimeStampToDateTime(unixTimeStamp);

        return (new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()).slice(0, -1);
    }

    static parseAmount(amount) {
        return parseFloat(amount).toFixed(2);
    }

    static getTradingWebApiUrl() {
        return API_URL.TRADING_API;
    }

    static getNameFromArrayById(array, id) {
        return array.filter(obj => {
            if (Number(obj.id) === Number(id)) {
                // return obj.name;
                return {
                    ...obj.name
                };
            }
        });
    }

    static isString(string) {
        try {
            if (Array.isArray(JSON.parse(string))) return false;
        } catch (e) {
            return false;
        }
        return true;
    }

    static getMessageString(type, variable, value = '') {
        let currentVariable = this.getTitleCase(this.removeNumbersFromString(this.removeSpacialCharactersFromString(variable))), currentValue = value;
        if (value.length > 0) {
            currentValue = this.getTitleCase(this.removeNumbersFromString(this.removeSpacialCharactersFromString(value)));
        }
        if (type === ROLE) return `${currentVariable} been set as ${currentValue} successfully.`
        if (type === ACCESS_CHANGE) return value && value.toLowerCase().includes('admin') ? `Admin access updated for ${currentVariable} successfully.` : `Access updated for ${currentVariable} successfully.`
        if (type === SENT) return `${currentVariable} sent successfully.`
        if (type === REPLACE) return `${currentVariable} has been successfully replaced.`
        if (type === TRANSACTION) return `${currentVariable} confirmed successfully.`
        if (type === SENT_FAILED) return `${currentVariable} could not be sent.`
        if (type === SHUFFLE) return `${currentVariable} shuffled successfully.`
        if (type === RELEASE) return `${currentVariable} release successfully.`
        if (type === MINTABLE) return `${currentVariable} is successfully mintable.`
        if (type === RESERVE) return `${currentVariable} reserve successfully.`
        if (type === SHUFFLE_FAILED) return `${currentVariable} shuffle failed.`
        if (type === SYNC) return `${currentVariable} synced successfully.`
        if (type === COMPLETE) return `${currentVariable} created successfully.`
        if (type === MINT) return `${currentVariable} minted successfully.`
        if (type === MINT_FAILED) return `${currentVariable} mint failed.`
        if (type === GIFTED) return `${currentVariable} gifted successfully.`
        if (type === GIFT_FAILED) return `${currentVariable} gift failed.`
        if (type === IMPORT) return `${currentVariable} imported successfully.`
        if (type === IMPORT_FAILED) return `${currentVariable} import failed.`
        if (type === DOWNLOAD_START) return `${currentVariable} download starting successfully.`
        if (type === DOWNLOAD_FAILED) return `${currentVariable} download failed.`
        if (type === DOWNLOAD_DATA_NOT_FOUND) return `No record found for ${variable} to download.`
        if (type === CREATE) return `${currentVariable} created successfully.`
        if (type === ADD) return `${currentVariable} added successfully.`
        if (type === UPDATE) return `${currentVariable} updated successfully.`
        if (type === DELETE) return `${currentVariable} deleted successfully.`
        if (type === CLOSE) return `${currentVariable} closed successfully.`
        if (type === EMPTY) return `${currentVariable} should not be empty.`
        if (type === REQUIRE) return `${currentVariable} is required.`
        if (type === GREAT) return `${currentVariable} should be greater than ${value} characters.`
        if (type === LESS) return `${currentVariable} should be less than ${value} characters.`
        if (type === LIMIT_GREAT) return `${currentVariable} should be greater than ${value} value.`
        if (type === LIMIT_LESS) return `${currentVariable} should be less than ${value} value.`
        if (type === URL) return `${currentVariable} should be a valid url.`
        if (type === DECIMAL) return `${currentVariable} can only be up-to 8 digits after decimal.`
        if (type === NUMERIC) return `${currentVariable} should not be a decimal value.`
        if (type === NOT_FOUND) return `${currentVariable} not found.`
        if (type === ALERT) return `Are you sure you want to ${variable}???`
        if (type === DISABLE) return `${currentVariable} disabled successfully.`
        if (type === ENABLE) return `${currentVariable} enabled successfully.`
        if (type === SELECT) return `Please select a ${variable} first.`
        if (type === IMAGE) return `Only jpg, png or jpeg files are allowed to upload.`
        if (type === VIDEO) return `Only mp4 files are allowed to upload.`
        if (type === DLC) return `Only .dlc files are allowed.`
        if (type === PAK) return `Only .pak files are allowed.`
        if (type === START_DATE_ERROR) return `Start Date cannot be set after ending date.`
        if (type === END_DATE_ERROR) return `Ending Date cannot be set before starting date.`
        if (type === REFILL) return `Collection is refilled successfully.`
        if (type === COMPLETE) return `${currentVariable} is completed successfully.`
        if (type === NETWORK.DEFAULT) return `Network Failed: while fetching ${variable}.`
        if (type === NETWORK.ROUTE_NOT_FOUND) return `Network Failed: url does not exist for ${variable}.`
        return `Something went wrong while fetching ${variable}.`
    }

    static parseAmount(amount) {
        return parseFloat(amount).toFixed(2)
    }

    static removeBracketsFromString(string) {
        return string.replace(/[\[\]']/g, '');
    }

    static convertCommaStringIntoArray(string) {
        return string.split(',');
    }

    static setNetworkRequestError(error, variable) {
        if (error.message !== undefined && error.message === "Network Error") {
            return {
                error_type: "danger",
                error_message: this.getMessageString(NETWORK.DEFAULT, variable)
            }
        }
        if (error.response !== undefined && error.response.status === NETWORK.NOT_FOUND) {
            return {
                error_type: "danger",
                error_message: this.getMessageString(NETWORK.ROUTE_NOT_FOUND, variable)
            }
        }
        return {
            error_type: "danger",
            error_message: this.getMessageString(NETWORK.FAILED_REQUEST, variable)
        }
    }

    static passwordValidation(password) {
        let data = password, error = "";

        const hasUpperChar = new RegExp("[A-Z]+")
        const hasMiniMaxChars = new RegExp(".{7,20}")
        const hasLowerChar = new RegExp("[a-z]+")
        const hasSymbols = new RegExp(
            "[!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/?]"
        )

        if (!hasMiniMaxChars.test(data)) {
            error = "Password should at least 7 characters long."
        }
        else if (!hasLowerChar.test(data)) {
            error = "Password should contain At least one lower case letter"
        }
        else if (!hasUpperChar.test(data)) {
            error = "Password should contain At least one upper case letter."
        }
        else if (!hasSymbols.test(data)) {
            error = "Password should contain At least one special case characters."
        }
        else if (password.length > 20) {
            error = "Password should NOT be longer than 20 characters"
        }
        else {
            error = ""
        }

        return error
    }

    static removeTextAfterLimit(text, max) {
        return text && text.length > max ? text.slice(0, max).split(' ').slice(0, -1).join(' ') + " ..." : text
    }

    static addClassToBody(className) {
        document.getElementsByTagName('body')[0].classList.add(className);
    }

    static removeClassFromBody(className) {
        document.getElementsByTagName('body')[0].classList.remove(className);
    }

    static removeValueFromArray(array, selectedValue) {
        let uniqueValue = true;
        for (let index = 0; index < array.length; index++) {
            if (array[index] === selectedValue) {
                console.log('found value in');
                uniqueValue = false;
                this.removeArrayFromIndex(array, index)
            }
        }
        return uniqueValue;
    }

    static removeArrayFromIndex(array, index, numberOfValues = 1) {
        if (index === 0) {
            array.shift();
            return array
        } else {
            array.splice(index, numberOfValues);
            return array;
        }
    }

    static clearNetworkRequest() {
        return {
            error_type: "",
            error_message: "",
        }
    }

    static clearDateRequest() {
        return {
            startdate_message: "",
            enddate_message: "",
        }
    }

    static clearModalRequest() {
        return {
            modal_error_message: "",
            modal_error_type: "",
        }
    }

    static getValueFromSelectedOption(name) {
        return document.getElementsByName(`${name}`)[0].selectedOptions[0].outerText
    }

    static getSingle(items, id) {
        return items.filter(function (item) {
            return item.id === id;
        });
    }

    static getSingleByName(items, name) {
        return items.filter(function (item) {
            return item.name === name && !item.isDeleted;
        });
    }

    static removeSpacialCharactersFromString(value, replaceWithSpace = true) {
        return value.replace(/[^a-zA-Z, ]/g, replaceWithSpace ? " " : "");
    }

    static removeSpacialCharactersOtherThanNumbersFromString(value, replaceWithSpace = true) {
        return value.replace(/[^a-zA-Z0-9, ]/g, replaceWithSpace ? " " : "");
    }

    static removeNumbersFromString(value) {
        return value.replace(/[0-9]/g, '');
    }

    static convertTimeToHumanReadableFormat(time) {
        let offset = moment().utcOffset();
        // return moment(time).utcOffset(offset).format("L LT");
        return moment(time).utc(false).format("L LT");
    }

    static showNotification(type = 'success', msg) {
        new Noty({
            type: type,
            theme: 'metroui',
            layout: 'topRight',
            text: msg,
            timeout: '3000'
        }).show();
    }
}